

// #region imports

// --- Angular
import { Component, OnInit, Input } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-hero-image',
  templateUrl: './hero-image.component.html',
  styleUrls: ['./hero-image.component.scss']
})
export class HeroImageComponent implements OnInit {

  @Input() desktopImage: string;
  @Input() tabletImage: string;
  @Input() mobileImage: string;

  constructor() { }

  ngOnInit() {
    if (!this.desktopImage) {
      throw new Error(`: desktopImage is required, but was not provided`);
    }
  }

}
